import { Injectable } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MatSnackBar } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtilityServicesService {

  constructor(private snackbar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private http: HttpClient
  ) { }

  openSnackBar(message: string) {
    this.snackbar.open(message, null, {
      duration: 3000,
    });
  }
  showSpinner() {
    this.spinnerService.show();
  }

  hideSpinner() {
    this.spinnerService.hide();
  }

  getInstruction() {
    return this.http.get('../../assets/json/directions.json')

  }
  getInfo() {
    return this.http.get('../../assets/json/info.json')
  }

  getPortalData() {
    return this.http.get('../../assets/json/portallink.json')
  }

  getCodingClubUserInfo(email:string){
    return this.http.get(environment.codinClubUrl+`/codin-club/user/${email}`)
     
   }

   getResultTopic() {
    return this.http.get('../../assets/json/Testpoints.json')
  }
}
